<template>
  <div>
    <el-alert
      title="到期或强制生成维保工单，单号走编号规则（回退 BY 前缀）。生成时按模板发送维保邮件。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.planNumber" clearable placeholder="编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.planName" clearable placeholder="名称" style="width:140px" @keyup.enter.native="search" />
      <el-switch v-model="query.onlyDue" active-text="仅到期" style="margin-right:8px" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button @click="generateDue">批量生成到期</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="planNumber" label="编码" width="130" />
      <el-table-column prop="planName" label="名称" min-width="140" />
      <el-table-column prop="machineName" label="设备" min-width="140" />
      <el-table-column label="类型" width="80" align="center">
        <template slot-scope="{ row }">{{ row.moType === '01' ? '保养' : '维修' }}</template>
      </el-table-column>
      <el-table-column prop="cycleDays" label="周期(天)" width="90" align="center" />
      <el-table-column label="下次到期" width="120">
        <template slot-scope="{ row }">
          <span :style="isDue(row) ? 'color:#E6A23C;font-weight:600' : ''">{{ formatDate(row.nextDueDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="staffName" label="负责人" width="100" />
      <el-table-column prop="sourceCostName" label="源成本" width="120" />
      <el-table-column prop="lastGeneratedMoCode" label="最近工单" width="170" />
      <el-table-column label="启用" width="70" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="generateOne(row)">生成工单</el-button>
          <el-button type="text" @click="openEdit(row.planId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.planId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.planId ? '修改维保计划' : '新增维保计划'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="编码"><el-input v-model="form.planNumber" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.planName" /></el-form-item>
        <el-form-item label="设备">
          <el-select v-model="form.machineId" filterable style="width:100%">
            <el-option v-for="m in machines" :key="m.machineId" :label="m.machineCode + ' / ' + m.machineName" :value="m.machineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.moType" style="width:100%">
            <el-option label="保养" value="01" />
            <el-option label="维修" value="02" />
          </el-select>
        </el-form-item>
        <el-form-item label="周期(天)"><el-input-number v-model="form.cycleDays" :min="1" :max="3650" style="width:100%" /></el-form-item>
        <el-form-item label="工期(小时)"><el-input-number v-model="form.durationHours" :min="1" :max="720" style="width:100%" /></el-form-item>
        <el-form-item label="下次到期">
          <el-date-picker v-model="form.nextDueDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form.staffId" filterable clearable style="width:100%">
            <el-option v-for="s in staffs" :key="s.staffId" :label="s.staffNumber + ' / ' + s.staffName" :value="s.staffId" />
          </el-select>
        </el-form-item>
        <el-form-item label="源成本">
          <el-select v-model="form.sourceCostId" filterable clearable style="width:100%">
            <el-option v-for="c in costs" :key="c.sourceCostId" :label="c.sourceCostNumber + ' / ' + c.sourceCostName" :value="c.sourceCostId" />
          </el-select>
        </el-form-item>
        <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listMaintenancePlan, getMaintenancePlan, saveMaintenancePlan, updateMaintenancePlan,
  deleteMaintenancePlan, generateMaintenancePlan, generateDueMaintenancePlans
} from '../../api/maintenancePlan'
import { selectMachine } from '../../api/machine'
import { selectStaff } from '../../api/staff'
import { selectSourceCost } from '../../api/sourceCost'

function emptyForm() {
  return {
    planId: '', planNumber: '', planName: '', machineId: '', moType: '01',
    cycleDays: 30, durationHours: 8, nextDueDate: null, staffId: '', sourceCostId: '', description: '', active: '1'
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { planNumber: '', planName: '', onlyDue: false },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), machines: [], staffs: [], costs: []
    }
  },
  created() {
    this.load()
    selectMachine().then(res => { this.machines = res.data || [] }).catch(() => {})
    selectStaff().then(res => { this.staffs = res.data || [] }).catch(() => {})
    selectSourceCost().then(res => { this.costs = res.data || [] }).catch(() => {})
  },
  methods: {
    formatDate(v) { return v ? String(v).substring(0, 10) : '-' },
    todayText() {
      const today = new Date()
      return today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0')
    },
    isDue(row) {
      if (!row.nextDueDate || row.active !== '1') return false
      return String(row.nextDueDate).substring(0, 10) <= this.todayText() || row.due === true
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMaintenancePlan({
        currentPage: this.page, pageSize: this.pageSize,
        planNumber: this.query.planNumber, planName: this.query.planName, onlyDue: this.query.onlyDue
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getMaintenancePlan(id).then(res => {
        const p = res.data || {}
        this.form = {
          planId: p.planId, planNumber: p.planNumber, planName: p.planName, machineId: p.machineId,
          moType: p.moType || '01', cycleDays: p.cycleDays || 30, durationHours: p.durationHours || 8,
          nextDueDate: p.nextDueDate ? String(p.nextDueDate).substring(0, 10) : null,
          staffId: p.staffId || '', sourceCostId: p.sourceCostId || '', description: p.description || '', active: p.active || '1'
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.planNumber || !this.form.planName) { this.$message.warning('请填写编码和名称'); return }
      if (!this.form.machineId) { this.$message.warning('请选择设备'); return }
      this.saving = true
      const req = this.form.planId ? updateMaintenancePlan(this.form) : saveMaintenancePlan(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    generateOne(row) {
      const force = !this.isDue(row)
      const tip = force ? '计划尚未到期，确认强制生成维保工单？' : '确认按计划生成维保工单？'
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        generateMaintenancePlan(row.planId, force).then(res => {
          const code = (res.data && res.data.moCode) || ''
          this.$message.success('已生成工单 ' + code)
          this.load()
        })
      }).catch(() => {})
    },
    generateDue() {
      this.$confirm('批量生成所有到期计划的维保工单？', '提示', { type: 'warning' }).then(() => {
        generateDueMaintenancePlans().then(res => {
          const n = (res.data && res.data.count) || 0
          this.$message.success('已生成 ' + n + ' 张工单')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteMaintenancePlan([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
